import Button from '../../components/ui/Button/Button.jsx';
import styles from './NotFound.module.css';

export default function NotFound() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.wrap}`}>
        <span className={styles.code}>404</span>
        <h1 className={styles.title}>This page didn't make it to production</h1>
        <p className={styles.text}>
          The page you're looking for doesn't exist, or may have moved. Let's get you
          back to something real.
        </p>
        <div className={styles.actions}>
          <Button to="/" size="lg">Back to home</Button>
          <Button to="/contact" variant="secondary" size="lg">Contact us</Button>
        </div>
      </div>
    </section>
  );
}
